import { render, staticRenderFns } from "./resultsPage.vue?vue&type=template&id=9f971d58&scoped=true&"
import script from "./resultsPage.vue?vue&type=script&lang=js&"
export * from "./resultsPage.vue?vue&type=script&lang=js&"
import style0 from "./resultsPage.vue?vue&type=style&index=0&id=9f971d58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f971d58",
  null
  
)

export default component.exports